<template>
    <div class="centered-content">
        <div class="video-container">
            <video
                v-show="!blockedCamera"
                @playing="playing"
                autoplay
                ref="video"
                class="video"
            ></video>

            <div class="video-name">
                <p>{{ name }}</p>
            </div>

            <VideoPlaceholder v-if="blockedCamera" :name="name" />
        </div>
    </div>
</template>

<script>
import VideoPlaceholder from "./VideoPlaceholder.vue";

export default {
    name: "video-stream",
    components: {
        VideoPlaceholder,
    },
    props: {
        stream: { type: MediaStream },
        muted: { type: Boolean, default: false },
        blockedCamera: { type: Boolean, default: false },
        name: { type: String, required: true },
        isSmall: { type: Boolean, default: true },
    },
    mounted() {
        this.$refs.video.srcObject = this.stream;
        this.$refs.video.muted = this.muted;
    },
    watch: {
        stream(stream) {
            this.$refs.video.srcObject = stream;
        },
    },
    methods: {
        playing() {
            this.$emit("playing");
        },
        pin() {
            this.$emit("togglePin");
        },
        stopCamera() {
            this.$refs.video.srcObject.getTracks().forEach(function (track) {
                track.stop();
            });
        },
    },
};
</script>

<style lang="scss">
.centered-content {
    display: flex;
    justify-content: center;
}

.video-container {
    position: relative;
    --bs-aspect-ratio: calc(9 / 16 * 100%);
    width: 480px;

    & .video {
        position: relative;
        border-radius: 5px;
        max-width: 640px;
        width: 100%;
    }

    & .video-pin {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        opacity: 0;
        height: 35px;
        width: 35px;
        border-radius: 50%;
        background-color: #eee;
        border: none;

        & .icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        &:hover {
            cursor: pointer;
        }
        &:active,
        &:focus {
            outline: none;
            border: none;
        }
    }

    & .video-name {
        position: absolute;
        bottom: 5px;
        left: 0;

        opacity: 0;
        height: 150px;
        width: 100%;
        border-radius: 0 0 5px 5px;
        background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3));

        & p {
            position: absolute;
            bottom: 0.5rem;
            left: 0.5rem;
            color: white;
        }
    }

    &:hover {
        & .video-pin {
            opacity: 1;
        }
        & .video-name {
            opacity: 1;
        }
    }
}
</style>